import React from "react";

const useTableFilter = (options, placeHolder, tableData) => {
  const handleChange = (e) => {
    console.log("filteredData", tableData);
  };
  const TableFilter = () => {
    return (
      <>
        <select onChange={handleChange}>
          <option> {placeHolder} </option>
          {options?.length > 0 ? (
            options.map((option) => {
              return (
                <>
                  <option>{option.title}</option>
                </>
              );
            })
          ) : (
            <></>
          )}
        </select>
      </>
    );
  };

  return { TableFilter };
};

export default useTableFilter;
